// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'
import { withRouter } from 'react-router'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import Loading from 'components/Loading/Loading'
import Text from 'components/Form/Text'
import Textarea from 'components/Form/Textarea'
import Select from 'components/Form/Select'
import Checkbox from 'components/Form/Checkbox'
import TextSearch from 'components/Form/TextSearch'
import Place from 'components/Form/Place'
import File from 'components/Form/File'
import { doRequest } from 'utilities/request'
import { loop } from 'utilities/objects'
import { loopArray } from 'utilities/arrays'

class Register extends React.Component {
	constructor() {
		super()

		this.state = {
			isProcessing: false,
			isProcessed: false,
			hasSuccess: false,
			hasError: false,
			errorMessage: '',
			name: '',
			address: '',
			state: '',
			postcode: '',
			email: '',
			phone: '',
			password: '',
			store_name: '',
			store_location: '',
			product_name: '',
			product_size: '',
			serial_number: '',
			comment: '',
			has_stains: '',
			has_read_warrany: '',
			purchase_date: '',
			problem_noticed: ''
		}
	}

	handleChange = ( id, value ) => {
		this.setState( {
			[ id ]: value
		} )
	}

	handleChangeAddress = ( id, value, placeData ) => {
		this.setState( {
			[ id ]: value
		} )

		if ( placeData.state ) {
			this.setState( {
				state: placeData.state
			} )
		}

		if ( placeData.postcode ) {
			this.setState( {
				postcode: placeData.postcode
			} )
		}
	}

	handleSubmit = ( e ) => {
		e.preventDefault()

		const { dispatch, accountData } = this.props
		const {
			name, address, state, postcode, email, phone, password,
			store_name, store_location,
			product_name, product_size, serial_number, comment, has_stains, has_read_warrany, purchase_date, problem_noticed,
			serial_number_file, receipt_file,
			photo_mattress_file, photo_foundation_file, photo_sagging_file
		} = this.state
		const endpoint = accountData ? 'new-claim' : 'register'

		if ( ! accountData && ( ! name || ! email ) ) {
			this.setState( {
				hasError: true
			} )

			return
		}

		// Get files:
		let serialNumberFile, serialNumberFileName,
			receiptFile, receiptFileName,
			photoMattressFile, photoMattressFileName,
			photoFoundationFile, photoFoundationFileName,
			photoSaggingFile, photoSaggingFileName

		if ( serial_number_file && serial_number_file.length ) {
			serialNumberFile = serial_number_file[0]
			serialNumberFileName = serial_number_file[0].name
		}

		if ( receipt_file && receipt_file.length ) {
			receiptFile = receipt_file[0]
			receiptFileName = receipt_file[0].name
		}

		if ( photo_mattress_file && photo_mattress_file.length ) {
			photoMattressFile = photo_mattress_file[0]
			photoMattressFileName = photo_mattress_file[0].name
		}

		if ( photo_foundation_file && photo_foundation_file.length ) {
			photoFoundationFile = photo_foundation_file[0]
			photoFoundationFileName = photo_foundation_file[0].name
		}

		if ( photo_sagging_file && photo_sagging_file.length ) {
			photoSaggingFile = photo_sagging_file[0]
			photoSaggingFileName = photo_sagging_file[0].name
		}

		// Setup form data:
		const formData = new FormData()

		if ( ! accountData ) {
			formData.append( 'name', name )
			formData.append( 'address', address )
			formData.append( 'state', state )
			formData.append( 'postcode', postcode )
			formData.append( 'email', email )
			formData.append( 'phone', phone )
			formData.append( 'password', password )
		}

		formData.append( 'store_name', store_name )
		formData.append( 'store_location', store_location )

		formData.append( 'product_name', product_name )
		formData.append( 'product_size', product_size )
		formData.append( 'serial_number', serial_number )
		formData.append( 'comment', comment )
		formData.append( 'has_stains', has_stains )
		formData.append( 'has_read_warrany', has_read_warrany )
		formData.append( 'purchase_date', purchase_date )
		formData.append( 'problem_noticed', problem_noticed )

		if ( serialNumberFile ) {
			formData.append( 'serial_number_file', serialNumberFile, serialNumberFileName )
		}

		if ( receiptFile ) {
			formData.append( 'receipt_file', receiptFile, receiptFileName )
		}

		if ( photoMattressFile ) {
			formData.append( 'photo_mattress_file', photoMattressFile, photoMattressFileName )
		}

		if ( photoFoundationFile ) {
			formData.append( 'photo_foundation_file', photoFoundationFile, photoFoundationFileName )
		}

		if ( photoSaggingFile ) {
			formData.append( 'photo_sagging_file', photoSaggingFile, photoSaggingFileName )
		}

		// Send:
		this.setState( {
			isProcessing: true
		} )

		return doRequest( `${siteData.api_base_url}${endpoint}`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: formData
		} )
			.then( json => {
				this.showSuccess( accountData )
			} )
			.catch( error => {
				let errorMessage = ( error.data ) ? error.data.message : ''

				console.error( error.data, 'error' )
				this.showError( errorMessage )
			} )
	}

	showSuccess = ( accountData ) => {
		this.setState( {
			isProcessing: false,
			isProcessed: true,
			hasError: false,
			receipt_file: [],
			serial_number_file: [],
			photo_mattress_file: [],
			photo_foundation_file: [],
			photo_sagging_file: []
		} )

		setTimeout( () => {
			this.setState( {
				isProcessing: false,
				isProcessed: false,
				hasSuccess: true,
			} )

			setTimeout( () => {
				zenscroll.toY( 0 )
			}, 400 )

			if ( accountData ) {
				setTimeout( () => {
					this.props.history.push( '/' )
				}, 2000 )
			}
		}, 1000 )
	}

	showError = ( errorMessage ) => {
		this.setState( {
			isProcessing: false,
			hasSuccess: false,
			hasError: true,
			errorMessage: errorMessage
		} )
	}

	render() {
		const { requestedAccountData, accountData } = this.props
		const {
			isProcessing, isProcessed, hasSuccess, hasError, errorMessage,
			store_name, serial_number_file, receipt_file,
			photo_mattress_file, photo_foundation_file, photo_sagging_file
		} = this.state
		let showLoading = false
		let showSignupFields = true
		let formClass = 'form'

		if ( ! requestedAccountData ) {
			return null
		}

		if ( accountData ) {
			showSignupFields = false
		}

		if ( isProcessing ) {
			formClass += ' is-processing'
		}

		if ( isProcessed ) {
			formClass += ' is-processed'
		}

		if ( hasSuccess ) {
			formClass += ' is-successful'
		}

		if ( hasError ) {
			formClass += ' has-error'
		}

		let storesOptions = []
		let locationsOptions = [
			{
				name: '',
				value: ''
			}
		]

		loop( siteData.stores, ( key, item ) => {
			storesOptions.push( {
				name: item.title,
				value: item.customer_id || item.title
			} )

			if ( store_name && ( store_name == item.title || store_name == item.customer_id ) ) {
				loopArray( item.items, ( key, item ) => {
					locationsOptions.push( {
						name: item.title,
						value: item.customer_id || item.title
					} )
				} )
			}
		} )

		storesOptions.sort( ( a, b ) => a.name.localeCompare( b.name ) )
		locationsOptions.sort( ( a, b ) => a.name.localeCompare( b.name ) )

		return (
			<div className="page-plain">
				{ showLoading &&
					<Loading />
				}

				<div className="-inner">
					<div className="-content">
						{ hasSuccess && showSignupFields &&
							<div className="form-message">
								Please check your email to confirm your address.<br />
								Please check your Junk / Spam.
							</div>
						|| hasSuccess &&
							<div className="form-message">
								Your request has been sent.
							</div>
						}

						{ ! hasSuccess &&
							<form className={ formClass } action="" onSubmit={ this.handleSubmit }>
								{ showSignupFields &&
									<div className="form-section">
										<div className="form-item">
											<h3>Your details</h3>
										</div>

										<Text
											id="name"
											label="Name"
											onChange={ this.handleChange }
											uncontrolled={ true }
											required={ true }
										/>

										<Place
											id="address"
											label="Address"
											onChange={ this.handleChangeAddress }
											uncontrolled={ true }
											required={ true }
										/>

										<div className="form-item form-items-row">
											<Text
												type="email"
												id="email"
												label="Email"
												onChange={ this.handleChange }
												uncontrolled={ true }
												required={ true }
											/>

											<Text
												id="phone"
												label="Phone"
												onChange={ this.handleChange }
												uncontrolled={ true }
												required={ true }
												required={ true }
											/>
										</div>

										<Text
											type="password"
											id="password"
											label="Create a password"
											onChange={ this.handleChange }
											uncontrolled={ true }
											required={ true }
										/>
									</div>
								}

								<div className="form-section">
									<div className="form-item">
										<h3>Store details</h3>
									</div>

									<div className="form-item form-items-row">
										<TextSearch
											id="store_name"
											label="Store Name"
											onChange={ this.handleChange }
											options={ storesOptions }
											uncontrolled={ true }
											required={ true }
										/>

										{ 'other' == store_name &&
											<Text
												id="store_location"
												label="Enter Store"
												onChange={ this.handleChange }
												uncontrolled={ true }
												required={ true }
											/>
										||
											<Select
												id="store_location"
												label="Store Location"
												onChange={ this.handleChange }
												options={ locationsOptions }
												uncontrolled={ true }
											/>
										}
									</div>
								</div>

								<div className="form-section">
									<div className="form-item">
										<h3>Product details</h3>
									</div>

									<div className="form-item form-items-row">
										<Text
											id="product_name"
											label="Product Name"
											onChange={ this.handleChange }
											uncontrolled={ true }
											required={ true }
										/>

										<Select
											id="product_size"
											label="Product Size"
											onChange={ this.handleChange }
											uncontrolled={ true }
											required={ true }
											options={ [
												{
													value: '',
													name: ''
												},
												{
													value: 'Super King – 203 x 203',
													name: 'Super King – 203 x 203'
												},
												{
													value: 'King – 183 x 203',
													name: 'King – 183 x 203'
												},
												{
													value: 'Queen – 153 x 203',
													name: 'Queen – 153 x 203'
												},
												{
													value: 'Double – 138 x 188',
													name: 'Double – 138 x 188'
												},
												{
													value: 'King Single – 107 x 103',
													name: 'King Single – 107 x 103'
												},
												{
													value: 'Long Single – 92 x 203',
													name: 'Long Single – 92 x 203'
												},
												{
													value: 'Single – 92 x 188',
													name: 'Single – 92 x 188'
												}
											] }
										/>
									</div>

									<div className="form-item form-items-row">
										<Text
											id="serial_number"
											label="Serial Number"
											onChange={ this.handleChange }
											uncontrolled={ true }
											note={ `The serial number is a 7 digit number located on the manufacturing tag sewn into the back of the mattress. <a href="${siteData.images_url}serial-number-example.png" target="_blank"><strong>See example</strong></a>` }
										/>

										<File
											id="serial_number_file"
											label="Upload photo of serial number"
											buttonLabel="Choose a file..."
											value={ serial_number_file }
											onChange={ this.handleChange }
										/>
									</div>

									<div className="form-item">
										<h3>Mattress/Foundation Photos</h3>
									</div>

									<File
										id="photo_mattress_file"
										label="Mattress – all bedding removed"
										buttonLabel="Choose a file..."
										value={ photo_mattress_file }
										required={ true }
										onChange={ this.handleChange }
									/>

									<File
										id="photo_foundation_file"
										label="Foundation – showing the slats"
										buttonLabel="Choose a file..."
										value={ photo_foundation_file }
										required={ true }
										onChange={ this.handleChange }
									/>

									<File
										id="photo_sagging_file"
										label="Sagging/body impressions – How deep (broom handle across the area with a tape measure confirming the depth)"
										buttonLabel="Choose a file..."
										value={ photo_sagging_file }
										onChange={ this.handleChange }
									/>

									<div className="form-item">
										<h3>Other details</h3>
									</div>

									<Textarea
										id="comment"
										label="Document your issue"
										onChange={ this.handleChange }
										uncontrolled={ true }
										required={ true }
									/>

									<Select
										id="has_stains"
										label="Does your mattress have any stains?"
										onChange={ this.handleChange }
										uncontrolled={ true }
										required={ true }
										options={ [
											{
												value: '',
												name: ''
											},
											{
												value: 'yes',
												name: 'Yes'
											},
											{
												value: 'no',
												name: 'No'
											}
										] }
									/>

									<Select
										id="has_read_warrany"
										label="Have you read the warranty?"
										onChange={ this.handleChange }
										uncontrolled={ true }
										required={ true }
										options={ [
											{
												value: '',
												name: ''
											},
											{
												value: 'yes',
												name: 'Yes'
											},
											{
												value: 'no',
												name: 'No'
											}
										] }
										note={ `<a href="${siteData.assets_url}pdf/Warranty.pdf" target="_blank"><strong>View warranty</strong></a>` }
									/>

									<Text
										id="purchase_date"
										label="When did you purchase the mattress?"
										onChange={ this.handleChange }
										uncontrolled={ true }
										required={ true }
									/>

									<Text
										id="problem_noticed"
										label="When did you notice the problem?"
										onChange={ this.handleChange }
										uncontrolled={ true }
										required={ true }
									/>

									<File
										id="receipt_file"
										label="Upload receipt"
										buttonLabel="Choose a file..."
										value={ receipt_file }
										onChange={ this.handleChange }
									/>
								</div>

								<div className="form-section">
									<div className="form-item">
										<button className="button" type="submit"><span className="-state"></span><span className="-progress"></span>Submit</button>
									</div>
								</div>
							</form>
						}

						{ hasError &&
							<div className="form-message">
								{ errorMessage || 'Please complete the form.' }
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		requestedAccountData: state.user.requestedAccountData,
		accountData: state.user.accountData
	}
}

export default withRouter(
	connect( mapStateToProps )( Register )
)
